import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from './client';
import { GlobalProvider } from '../components/context/GlobalContext';
const enableMyAccount = (process.env.GATSBY_MYACCOUNT || null) === '0' ? false : true

export const wrapRootElement = ({ element }) => (
     <div className={enableMyAccount ? 'has-myacc' : 'no-myacc'}>
      <GlobalProvider>
      <ApolloProvider client={client}>{element}</ApolloProvider>
      </GlobalProvider>
   </div>
);
